export default "__VITE_ASSET__Rs_1hCNv__"